import { AxiosRequestConfig } from 'axios';

import api from './api';

interface TelasProps {
  url: string;
}

export function createInterceptors(): void {
  api.interceptors.request.use(async (config: AxiosRequestConfig) => {
    try {
      const token = await localStorage.getItem('@PortalUnicred/sessionToken');
      const user = await JSON.parse(
        localStorage.getItem('@PortalUnicred/user') as any,
      );

      if (token) {
        const pathName = '/' + window.location.pathname.split('/')[1];

        config.headers.authorization = `Bearer ${token}`;

        const telas = user.telas.map(
          (telas: any): TelasProps => {
            return telas.url.replace('/listar', '');
          },
        );

        const checkValue = (value: any, arr: any) => {
          let status = 'Sem acesso';

          for (var i = 0; i < arr.length; i++) {
            var name = arr[i];
            if (name === value) {
              status = 'Acesso';
              break;
            }
          }

          return status;
        };

        if (user.roles[0] === 'interno') {
          if (
            pathName === '/home' ||
            pathName === '/perfil' ||
            pathName === '/telas' ||
            pathName === '/cooperado' ||
            checkValue(pathName, telas) === 'Acesso'
          ) {
          } else {
            window.location.href = `${window.location.origin}/acesso/negado`;
          }
        } else if (
          pathName === '/home' ||
          pathName === '/cooperado' ||
          checkValue(pathName, telas) === 'Acesso'
        ) {
        } else {
          window.location.href = `${window.location.origin}/acesso/negado`;
        }
      }

      return config;
    } catch (err) {
      return Promise.reject(err);
    }
  });

  api.interceptors.response.use(
    async response => {
      if (
        response.config.url === `/perfil/${response.data.id}` &&
        response.config.method === 'put'
      ) {
        const get = await api.get('/autenticado');

        localStorage.removeItem('@PortalUnicred/user');
        localStorage.setItem('@PortalUnicred/user', JSON.stringify(get.data));
      }

      return response;
    },
    async error => {
      const { data }: any = error.response;

      if (
        error.response.status === 406 ||
        (data.message ===
          'A sua sessão expirou, por favor efetue login novamente.' &&
          data.message === 'UNAUTHORIZED') ||
        data.error === 'Not Acceptable'
      ) {
        window.location.href = `${window.location.origin}/acesso/expirado`;
        localStorage.removeItem('@PortalUnicred/sessionToken');
        localStorage.removeItem('@PortalUnicred/user');
      } else if (
        error.response.status === 403 ||
        (data.details &&
          data!?.details[0]! ===
            'Usuário não autenticado nos sistemas da  Unicred.' &&
          data.message === 'UNAUTHORIZED')
      ) {
        window.location.href = `${window.location.origin}/acesso/negado`;
      } else if (
        error.response.status === 403 ||
        data!?.details[0]! ===
          'Usuário não autenticado nos sistemas da Unicred.'
      ) {
        localStorage.setItem('@PortalUnicred/expire', window.location.href);
        window.location.href = `${window.location.origin}/acesso/negado`;
      }
    },
  );
}
